/* unplugin-vue-components disabled */import script from "./tab.vue?vue&type=script&setup=true&lang=js"
export * from "./tab.vue?vue&type=script&setup=true&lang=js"

import "./tab.vue?vue&type=style&index=0&id=d5fb5bf4&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5fb5bf4"]])

export default __exports__